import React from "react";

function Color_Win8() {
  return (
    <div>
      <h1>Color_Win8 Component</h1>
      <p>This is the Color Win8 tutorial page content.</p>
    </div>
  );
}

export default Color_Win8;
